
import { Outlet } from 'react-router-dom';
export type MarketingProps = {}
const MarketingModule:React.FC<MarketingProps> = () => {
  return (
    <Outlet/>
  )
}
export default MarketingModule